export default "__VITE_ASSET__DADE9mxK__"